// @ts-nocheck generated file code from Facebook
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable fp/no-arguments */
import { FC, useEffect } from 'react';

import { useRendererContext } from 'js/shared/contexts/RendererContext';

const FACEBOOK_PIXEL_ID = import.meta.env.VITE_FACEBOOK_PIXEL_ID;

let mounted = false;
export const Facebook: FC = () => {
  const { isRenderer } = useRendererContext();

  useEffect(() => {
    if (isRenderer || mounted) return;

    if (FACEBOOK_PIXEL_ID) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', FACEBOOK_PIXEL_ID);
      window.fbq('track', 'PageView');
    }
    mounted = true;
  }, [isRenderer]);

  return null;
};
